import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CountryOption, GenericOption } from '@anytag/shared-types';

const COUNTRY_KEY = 'Country';

export const useTranslateCountryOptions = (options: CountryOption[] = []): CountryOption[] =>
  useTranslateOptions(options, COUNTRY_KEY);

// Country Translation Function
export const useTranslateCountry = () => {
  const { t } = useTranslation();
  const tc = (value: string) => t(`${COUNTRY_KEY}.${value.includes('.') ? value.replace(/[.]/g, '') : value}`);

  return { tc };
};

export const useTranslateOptions = <T extends string>(
  options: GenericOption<T, string>[] = [],
  key = 'Option'
): GenericOption<T, string>[] => {
  const { t, i18n, ready } = useTranslation();

  const translatedOptions = useMemo(
    () =>
      options.map<GenericOption<T, string>>((option) => ({
        ...option,
        label: t<string>(`${key}.${option?.label?.includes('.') ? option?.label?.replace(/[.]/g, '') : option.label}`)
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n.language, options.length, ready, key]
  );

  return translatedOptions;
};
